import styled from 'styled-components';

import { WideChevronDownBoldIcon } from '../../icons';
import { COOKIE_CONSENT_BANNER_ZINDEX } from '../cookie-consent-banner/CookieConsentBanner';

export const Container = styled.div`
	position: fixed;
	bottom: 0;
	right: 0;
	left: 0;
	top: 0;
	z-index: ${COOKIE_CONSENT_BANNER_ZINDEX + 1};
`;

export const Background = styled(Container)`
	background: #001625;
	position: absolute;
`;

export const Foreground = styled.div<{
	$background?: string;
	$detached: boolean;
	$fullHeight: boolean;
	$modalHeight: number;
	$showCloseButton: boolean;
}>`
	position: absolute;
	z-index: ${COOKIE_CONSENT_BANNER_ZINDEX + 1};
	right: 0;
	left: 0;
	bottom: ${({ theme }) => theme.spacings.xxlarge};
	height: ${({ $fullHeight, $modalHeight }) => ($fullHeight ? `${$modalHeight}px;` : 'auto')};
	max-height: ${({ $modalHeight }) => `${$modalHeight}px`};
	margin: ${({ $detached, theme }) =>
		$detached
			? `${theme.spacings.xlarge} ${theme.spacings.small} ${theme.spacings.small} ${theme.spacings.small}`
			: `${theme.spacings.xlarge} 0 0 0`};
	padding: ${({ $showCloseButton, theme }) =>
		`${$showCloseButton ? 0 : theme.spacings.xxlarge} ${theme.spacings.small} ${theme.spacings.small} ${
			theme.spacings.small
		}`};
	${({ $detached, theme }) => ($detached ? theme.border.radius.xlarge : theme.border.radius.xlargeTop)};
	background: ${({ $background, theme }) => $background ?? theme.colors.backgrounds.main.container};
	align-items: center;
	display: flex;
	flex-direction: column;
	& > * {
		max-width: ${({ theme }) => `${theme.breakpoints.points.tabletSmallDesktop.pageWidth}px`};
		width: 100%;
	}
`;

export const Header = styled.div`
	touch-action: none;
`;

export const SubHeader = styled.div`
	width: 100%;
	margin-bottom: ${({ theme }) => theme.spacings.large};
`;

export const StyledChevronIcon = styled(WideChevronDownBoldIcon)<{ $color?: string }>`
	display: block;
	margin: 0 auto;
	height: 48px;
	width: 48px;
	margin-top: ${({ theme }) => `${theme.spacings.xxsmall}`};
	fill: ${({ $color, theme }) => $color ?? theme.colors.icons.main.unselected};
`;

export const Content = styled.div`
	flex-grow: 1;
	overflow-y: auto;
`;

export const Footer = styled.div`
	margin-top: ${({ theme }) => theme.spacings.large};
`;
